<template>
  <div
    v-if="shouldRender"
    class="d-flex flex-column ga-4"
  >
    <h2 class="fs-24">
      {{ $bct('To do') }}
    </h2>

    <DashboardTask
      v-for="task in props.tasks"
      @reload-tasks="$emit('reload-tasks')"
      :key="task.id"
      :task="task"
    />
  </div>
</template>

<script setup>
import DashboardTask from '@/parent/components/dashboards/DashboardTask.vue';

const props = defineProps({
  tasks: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['reload-tasks']);

const $bct = inject('translator');

const shouldRender = computed(() => {
  return props.tasks.length > 0;
});
</script>
